import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './types';
import menuList from "../Infrustructure/menu";
import storageService from '../Infrustructure/localStorageService'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        token: storageService.getItem('token'),
        user: storageService.getItem('user') ? JSON.parse(storageService.getItem('user')) : {},
        menus: menuList,
        menuIndex: ""
    },
    mutations: {
        [types.LOGIN]: (state, data) => {
            let { access_token, userId, userName, roles, permissions } = data;
            state.token = access_token;
            state.user = { userId, userName };
            state.user.roles = roles ? roles.split(",") : [];
            state.user.permissions = permissions ? permissions.split(",") : [];
            try {
                storageService.setItem('token', state.token);
                storageService.setItem('user', JSON.stringify(state.user));
            } catch (e) {
                alert(e)
            }
        },
        [types.LOGOUT]: (state) => {
            state.token = '';
            state.user = {};
            storageService.removeItem('token');
            storageService.removeItem('user');
        },
        [types.MENUINDEX]: (state, data) => {
            state.menuIndex = data;
        },
    },
    getters: {
        token: (state) => {
            return state.token;
        },
        user: state => {
            return state.user;
        },
        menus: state => {
            let user = state.user;
            if (user.roles && user.roles.includes("Administrator")) {
                state.menus = menuList;
            } else {
                let permissions = user.permissions && user.permissions.map(p => {
                    if (p.includes(".")) {
                        return p.split(".")[0];
                    }
                    return p;
                });

                if (permissions) {
                    state.menus = menuList.filter(m => permissions.find(p => p === m.name));
                }
            }
            return state.menus;
        },
        menuIndex: state => {
            return state.menuIndex;
        },
        roles: state => {
            return state.user.roles;
        },
        permissions: state => {
            return state.user.permissions;
        }
    },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js